module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 11.0ab9c9b7.png";